import { FormHTMLAttributes, PropsWithChildren } from 'react'
import { FormProvider, SubmitErrorHandler, SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'
import { FieldValues } from 'react-hook-form/dist/types/fields'

export type FormContainerProps<T extends FieldValues = FieldValues> = PropsWithChildren<
  UseFormProps<T> & {
    formContext: UseFormReturn<T>
    onSuccess: SubmitHandler<T>
    onError?: SubmitErrorHandler<T>
    FormProps?: FormHTMLAttributes<HTMLFormElement>
    onBlur?: React.FocusEventHandler<HTMLFormElement>
  }
>

export default function FormContainer<TFieldValues extends FieldValues = FieldValues>({
  children,
  FormProps,
  formContext,
  onSuccess,
  onError,
  onBlur,
}: PropsWithChildren<FormContainerProps<TFieldValues>>) {
  return (
    <FormProvider {...formContext}>
      <form noValidate {...FormProps} onSubmit={formContext.handleSubmit(onSuccess, onError)} onBlur={onBlur}>
        {children}
      </form>
    </FormProvider>
  )
}
